export const NEXT_PAGE = 'NEXT_PAGE';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SET_PAGE = 'SET_PAGE';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';

export const SET_DUPLICATE_PARTNER = 'SET_DUPLICATE_PARTNER';
